/**
 * Cart Reorder Color Restore
 * Handles the "Farbton übernehmen" button in cart when a reordered item
 * is missing its custom color properties (Farbe, Bez, RGB, Modus).
 *
 * Flow: Add new item with restored properties → only on success remove old line item → Reload
 * (Add-zuerst, damit die Position bei einem fehlgeschlagenen Add nicht ersatzlos verloren geht)
 */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-color-restore__btn');
    if (!btn) return;

    var container = btn.closest('.cart-color-restore');
    if (!container) return;

    var lineKey = container.dataset.lineKey;
    var oldVariantId = parseInt(container.dataset.oldVariantId, 10);
    var variantId = oldVariantId || parseInt(container.dataset.variantId, 10);
    var quantity = parseInt(container.dataset.quantity, 10);
    var oldFarbe = container.dataset.oldFarbe || '';
    var oldBez = container.dataset.oldBez || '';
    var oldRgb = container.dataset.oldRgb || '';
    var oldModus = container.dataset.oldModus || '';

    if (!lineKey || !variantId) return;

    // Regel 2026-07-09 (Review-Befund): Ein ECHTER Farbton darf nicht auf einer
    // Weiß-Variante wiederhergestellt werden — Bestellungen aus dem Weißton-
    // Bug-Fenster (21.06.–08.07.) trugen z.B. RAL9003 auf der weiß-Variante
    // zum Weiß-Preis. In dem Fall: Auswahl auf der Produktseite neu auflösen
    // (Deep-Link trägt den Ton; die PDP wählt Artikel + Preisstufe korrekt).
    var FERTIG_WEISS = ['AW11', 'AW15', 'RAL9010', 'RAL9016', 'NS01213'];
    var farbKey = (oldFarbe || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    var istEchterTon = farbKey && ['WEI', 'WEISS', 'TRANSPARENT', 'KLAR', 'FARBLOS'].indexOf(farbKey) === -1;
    var istFertigWeiss = FERTIG_WEISS.some(function (f) { return farbKey === f || farbKey.indexOf(f) === 0; });
    var zielTitel = ((oldVariantId ? container.dataset.oldVariantTitle : container.dataset.variantTitle) || '');
    var zielIstWeiss = /wei(ß|ss)/i.test(zielTitel);
    var productUrl = container.dataset.productUrl || '';
    if (istEchterTon && !istFertigWeiss && zielIstWeiss && productUrl) {
      var u = productUrl + '?bez=' + encodeURIComponent(oldBez || oldFarbe) +
        '&color=' + encodeURIComponent(oldFarbe) +
        (oldRgb ? '&rgb=' + encodeURIComponent(oldRgb) : '');
      window.location.href = u;
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Wird übernommen…';
    btn.style.opacity = '0.6';

    // Step 1: Add same item with restored color properties FIRST —
    // so geht die Position nicht verloren, falls das Hinzufügen fehlschlägt
    var properties = {};
    if (oldFarbe) properties['Farbe'] = oldFarbe;
    if (oldBez) properties['Bez'] = oldBez;
    if (oldRgb) properties['RGB'] = oldRgb;
    if (oldModus) properties['Modus'] = oldModus;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties,
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Hinzufügen fehlgeschlagen');
        return res.json();
      })
      .then(function () {
        // Step 2: Nur nach erfolgreichem Add die alte Position ohne Farb-Properties entfernen
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
      })
      .then(function (res) {
        if (!res.ok) {
          // Add war erfolgreich, Entfernen nicht → Artikel liegt jetzt doppelt im Warenkorb
          var dupErr = new Error('Entfernen fehlgeschlagen');
          dupErr.ftkDuplicate = true;
          throw dupErr;
        }
        return res.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Farbton-Wiederherstellung fehlgeschlagen:', err);
        if (err && err.ftkDuplicate) {
          // Kein Retry anbieten — ein erneuter Klick würde den Artikel noch einmal hinzufügen
          btn.textContent = 'Bitte prüfe deinen Warenkorb — der Artikel könnte doppelt enthalten sein.';
          btn.style.opacity = '1';
          return;
        }
        btn.disabled = false;
        btn.textContent = 'Fehler – nochmal versuchen';
        btn.style.opacity = '1';
      });
  });
})();
